var _defs, _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.7,
    height: 23.7,
    x: 0.15,
    y: 0.15,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 0.3,
    rx: 2.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD6020",
    d: "M14.626 23.877l20.07-5.896v3.103a2.793 2.793 0 01-2.793 2.793H14.626z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.68 9.745c1.08 0 1.675.481 1.675 1.39a1.3 1.3 0 01-1.081 1.389l1.459 1.977h-1.135l-1.243-1.924h-.108v1.924h-.918V9.745h1.35zm-.433 2.19h.27c.595 0 .865-.266.865-.747 0-.428-.27-.695-.865-.695h-.27v1.443zm-4.106 2.566h2.593v-.802H27.06v-1.282h1.621v-.802h-1.62v-1.068h1.674v-.802h-2.593v4.756zm-2.702-1.55l-1.243-3.206h-.972l1.999 4.863h.486l2-4.863h-.973l-1.297 3.206zM12.47 12.15c0 1.336 1.08 2.458 2.432 2.458.432 0 .81-.107 1.188-.268v-1.068c-.27.32-.648.534-1.08.534-.865 0-1.567-.641-1.567-1.496v-.107c-.054-.855.648-1.603 1.513-1.656.432 0 .864.213 1.134.534v-1.069c-.324-.214-.756-.267-1.134-.267-1.405-.107-2.486 1.015-2.486 2.405zm-1.675-.588c-.54-.214-.702-.32-.702-.588.054-.32.324-.588.648-.534.27 0 .54.16.757.374l.486-.642c-.378-.32-.865-.534-1.35-.534-.757-.053-1.406.534-1.46 1.283v.053c0 .641.27 1.015 1.135 1.283.216.053.432.16.648.267a.56.56 0 01.27.48c0 .375-.324.695-.648.695h-.054c-.432 0-.81-.267-.973-.641l-.594.588c.324.588.973.908 1.621.908a1.518 1.518 0 001.621-1.443v-.16c-.054-.641-.324-.962-1.405-1.39zM7.661 14.5h.919V9.745H7.66v4.756zM3.393 9.745h1.62c1.297.054 2.324 1.123 2.27 2.405 0 .695-.324 1.336-.865 1.817-.486.374-1.08.588-1.675.534h-1.35V9.745zM4.58 13.7c.433.054.919-.107 1.243-.374.324-.32.486-.748.486-1.229 0-.427-.162-.855-.486-1.175a1.723 1.723 0 00-1.243-.374h-.27v3.152h.27z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD6020",
    fillRule: "evenodd",
    d: "M18.846 9.635c-1.35 0-2.485 1.069-2.485 2.458 0 1.336 1.08 2.458 2.485 2.511 1.405.054 2.486-1.068 2.54-2.458-.054-1.39-1.135-2.511-2.54-2.511z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.0f38b94c.svg";
export { ForwardRef as ReactComponent };